<template lang="pug">
	.error
		h1 There was an #[span error] loading data for this {{tag}}.
		h5 We apologize for the inconvenience, please try again later.
</template>


<script>
export default {
	name: 'Error',
	props: ["tag"]
}
</script>


<style lang="scss" scoped>
.error {
	@include container;
	display: flex;
	flex-direction: column;
	min-height: 80vh;
	align-items: center;
	justify-content: center;
}

h1 {
	font-size: 48px;
	text-align: center;
	margin: 0 0 20px;
	color: #333;
	font-family: 'DIN-bold';
	span {
		color: #bb0000;
	}
}

h5 {
	font-size: 28px;
	text-align: center;
	margin: 0;
	color: #333;
	font-family: 'DIN-bold';
}
</style>
